<template>
    <main>
        <div class="content" :style="{color}">
          {{ content }}
        </div>
    </main>
</template>

<script>
export default {
    props:{
        content:{
            type:String,
            default:""
        },
        color:{
            type:String,
            default:"#919599"
        }
    }
}
</script>
<style lang="less" scoped>
    .content{
        text-align: justify;
        margin: 0 0 3%;
        font-size: .825rem;
        color: #919599;
        @media (max-width: 768px) {
            font-size:1rem;
        }
    }
</style>
